import { css, SoloLitElement } from '@core/solo-lit-element';
import config from '../../config/config';
import authService from '../../utils/authService';

export class SoloAuthIframe extends SoloLitElement {
  static get is() {
    return `solo-auth-iframe`;
  }

  static get styles() {
    return css`
        :host {
            width: 0;
            height: 0;
        }

        .login-frame {
            width: 0;
            height: 0;
            border: none;
            position: absolute;
        }
    `;
  }

  static get properties() {
    return {
      iframeUrl: {
        type: String,
      },
    };
  }

  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    this.iframeUrl = `${config.authIframeUrl}?prompt=none&lang=${this.lang}`;
    authService.checkLoggedIn((loggedIn) => {
      this._createIframe(loggedIn);
    });
  }

  connectedCallback() {
    super.connectedCallback();
    let loginCallbackMessage = (e) => {
      if (!config.ssoTrustedOrigins.includes(e.origin)) {
        return;
      }

      try {
        const data = JSON.parse(e.data);
        if (!data || !data.fromSolo) {
          return;
        }
        if (data.login) {
          localStorage.setItem('loggedIn', true);
          window.dispatchEvent(new CustomEvent('logged-in', {bubbles: true, composed: true}));
          // this._addTimer();
        } else {
          window.dispatchEvent(new CustomEvent('logged-failed', {bubbles: true, composed: true}));
        }
      } catch {
        window.dispatchEvent(new CustomEvent('logged-failed', {bubbles: true, composed: true}));
      }
      window.removeEventListener('message', loginCallbackMessage);
      this._removeIframe();
    };
    loginCallbackMessage = loginCallbackMessage.bind(this);
    window.addEventListener('message', loginCallbackMessage);
    // window.addEventListener('logged-in', () => {
    //   this._addTimer();
    // });
  }

  _createIframe(loggedIn) {
    if (loggedIn) {
      localStorage.setItem('loggedIn', true);
      window.dispatchEvent(new CustomEvent('logged-in', {bubbles: true, composed: true}));
      // this._addTimer();
    } else {
      const iframe = document.createElement('iframe');
      iframe.className = 'login-frame';
      iframe.setAttribute('src', this.iframeUrl);
      this.iframe = iframe;
      this.shadowRoot.appendChild(iframe);
    }
  }

  _removeIframe() {
    try {
      this.shadowRoot.querySelector('.login-frame')?.remove();
    } catch (err) {
      console.warn(err);
    }
    delete this.iframe;
  }

  _checkSession() {
    this.apiCall('auth/check')
        .catch((err) => {
          if (err.status === 401) {
            location.reload();
          }
        });
  }

  _addTimer() {
    return;
    // window.removeEventListener('message', this._timeCallback);
    // window.addEventListener('message', this._timeCallback);
    // if (this._interval) {
    //   clearInterval(this._interval);
    // }
    // if (this._sessionInterval) {
    //   clearInterval(this._sessionInterval);
    // }
    // this._interval = setInterval(() => {
    //   this._createIframe();
    // }, 1000 * 15);
    // this._sessionInterval = setInterval(() => {
    //   this._checkSession();
    // }, 1000 * 60 * 20);
  }

  _timeCallback(e) {
    this._removeIframe();
    if (config.ENV === 'PRODUCTION') {
      console.clear();
    }
    try {
      const data = JSON.parse(e.data);
      if (!data.login) {
        this._logout();
      }
    } catch {
      // this._logout();
    }
  }

  _logout() {
    localStorage.removeItem('loggedIn');
    this.apiCall('auth/logout')
        .then((res) => {
          location.href = res.json.logoutUrl;
        })
        .catch((err) => console.log(err));
  }
}

window.customElements.define(SoloAuthIframe.is, SoloAuthIframe);
